const plan = {
  add_new: "新規プラン追加",
  edit: "プラン編集",
  plan_name: "プラン名",
  plan_name_placeholder: "入力してください",
  amount: "金額/月（税込）",
  price_prefix: "円",
  amount_placeholder: "入力してください",
  number_of_students: "受講生追加できる人数",
  number_of_students_placeholder: "入力してください",
  cancel_button: "キャンセル",
  save_draft_button: "下書き保存",
  save_button: "保存",
  student_limit_min: '受講生追加可能人数は10以上で入力してください。',
  student_limit_max: '受講生追加可能人数は1000以内で入力してください。',
  save_confirm: {
    title: "更新確認",
    content: "ご指定のプランを更新します。よろしいでしょうか。\n※更新内容は登録フォームに反映され、既存ユーザーに通知メールを送りますので、ご留意ください。",
    cancel: "キャンセル",
    save: "はい",
  },
  required: {
    student_limit: "受講生追加可能人数を入力してください。",
  },
  save_success: "新しいプランを作成しました。",
  edit_success: "ご指定のプランを更新しました。",
  plan_name_already_exists: "ご登録のプラン名は既に存在しますため、登録できません。再度お試しください。",
}

export default plan;